/*
 * Author: Blue Lobster Private Limited
 * Copyright: Blue Lobster Private Limited
 */
import { useEffect } from "react";
import Router from "./route/Index";

const App = () => {
	useEffect(() => {
		// Global autofill prevention - apply attributes to all inputs
		const applyAutofillPrevention = () => {
			const inputs = document.querySelectorAll("input, textarea, select");
			inputs.forEach((input) => {
				// Set autocomplete attributes
				input.setAttribute("autocomplete", "off");
				input.setAttribute("autoCorrect", "off");
				input.setAttribute("autoCapitalize", "off");
				input.setAttribute("spellCheck", "false");
				input.setAttribute("data-form-type", "other");
				input.setAttribute("data-lpignore", "true");
			});
		};

		// Apply prevention immediately
		applyAutofillPrevention();

		// Also apply to dynamically added inputs
		const observer = new MutationObserver(() => {
			applyAutofillPrevention();
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});

		// Cleanup observer on unmount
		return () => {
			observer.disconnect();
		};
	}, []);

	return <Router />;
};

export default App;
